// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2qTuO","modalForm":"UpgradeEpcsModal_modalForm__Mqu_R","modalFooter":"UpgradeEpcsModal_modalFooter__2JsGG"};